import styled from "styled-components";
import { useTheme } from "../../contexts/ThemeContext";

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;

  @media (min-width: 769px) {
    display: none; // Geniş ekranlarda tamamen gizle
  }
`;

const MenuText = styled.span<{ isDark: boolean }>`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ isDark }) => (isDark ? "#f5f5f5" : "#333")};
  user-select: none;

  @media (max-width: 250px) {
    display: none; // Çok küçük ekranlarda sadece ikon göster
  }
`;

const IconWrapper = styled.div`
  padding: 0.5rem;
  z-index: 1001;
`;

const IconBar = styled.span<{ isDark: boolean }>`
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px 0;
  background-color: ${({ isDark }) => (isDark ? "#f5f5f5" : "#333")};
  transition: all 0.3s ease;
`;

type HamburgerIconProps = {
  isOpen: boolean;
  onClick: () => void;
};

export const HamburgerIcon = ({ isOpen, onClick }: HamburgerIconProps) => {
  const { isDark } = useTheme();

  return (
    <IconContainer onClick={onClick}>
      <MenuText isDark={isDark}>Menü</MenuText>
      <IconWrapper aria-label={isOpen ? "Menüyü kapat" : "Menüyü aç"}>
        <IconBar
          isDark={isDark}
          style={{
            transform: isOpen ? 'rotate(-45deg) translate(-5px, 6px)' : 'none',
          }}
        />
        <IconBar
          isDark={isDark}
          style={{
            opacity: isOpen ? 0 : 1,
          }}
        />
        <IconBar
          isDark={isDark}
          style={{
            transform: isOpen ? 'rotate(45deg) translate(-5px, -6px)' : 'none',
          }}
        />
      </IconWrapper>
    </IconContainer>
  );
};